
import CustomeIcon from "../../components/CustomeIcon";
import Button from "../../components/Button";
import { Children, useState } from "react";

const IconMenu = (props) => {

    //    const [active,setActive]=useState(false);

    //     const IconActive=()=>{
    //         console.log("the icon is clicked");
    //         active ? setActive(false) : setActive(true);
    //     }

    let animClass = "iconBtn";
    props.mainAccordionShowHide ? animClass = "iconBtn active" : animClass = "iconBtn";
    // console.log("side menu Icon",props.mainAccordionFunc);

    return (
        <>



            <Button btnId={props.id + 'IconBtn'} classList={props.classList} clickFunction={props.mainAccordionFunc} data={props} >
                {/* in the custonIcon the src prop is added for the leftmenu icon */}

                <CustomeIcon alt={props.CategoryTitile} classList={props.iconClassList}></CustomeIcon>

                {/* <LeftmenuIcon src={props.LeftIconSrc} srca={props.LeftIconSrcActive} alt={props.CategoryTitile} classList={props.iconClassList} classList_active={props.classList_active}></LeftmenuIcon> */}

                <span className={props.TooltipClass}>{props.TooltipTitle}</span>

            </Button>

        </>
    );
}

export default IconMenu;


//   classList_active